
import { Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { DocumentId__get_unwrap, DocumentDetailLinkedInspectionResultInformation_$reflection, DocumentDetailLinkedReminderInformation_$reflection, DocumentId_$reflection } from "../../Shared/Shared.js";
import { record_type, option_type, bool_type, class_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ImageViewer } from "../../Components/ImageViewer.js";
import { tryFind, tryHead, item, length, ofArray, toArray, map, singleton } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { toArray as toArray_1, empty, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Delete_FileDeleteDialog, Edit_FileEditDialog, Upload_FileUploadDialog } from "../Dialogs/FileUploadDialog.js";
import { DeleteDocumentReminderLinkDialog } from "../Dialogs/DeleteReminderLinkDialog.js";
import { TableControl$1, Table } from "./Table.js";
import { equals, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import Convert_PDF_2 from "../../../public/assets/icons/Convert_PDF_2.svg";
import { ColumnDefinition$1, CellContent } from "./Types.js";
import New_File from "../../../public/assets/icons/New_File.svg";
import { Modal_OpenLinkDocumentWithReminderModalSheet } from "../LinkDocumentWithReminderModal.js";
import { TextButton } from "../../Components/Button.js";
import Upload_File from "../../../public/assets/icons/Upload_File.svg";
import Download_File from "../../../public/assets/icons/Download_File.svg";
import Pencil from "../../../public/assets/icons/Pencil.svg";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";

export class TableDocument extends Record {
    constructor(Id, Description, UploadDate, Name, FileName, VisibleForUserRole, Url, LinkedReminderInformation, LinkedInspectionResultInformation) {
        super();
        this.Id = Id;
        this.Description = Description;
        this.UploadDate = UploadDate;
        this.Name = Name;
        this.FileName = FileName;
        this.VisibleForUserRole = VisibleForUserRole;
        this.Url = Url;
        this.LinkedReminderInformation = LinkedReminderInformation;
        this.LinkedInspectionResultInformation = LinkedInspectionResultInformation;
    }
}

export function TableDocument_$reflection() {
    return record_type("Widgets.DocumentTable.TableDocument", [], TableDocument, () => [["Id", DocumentId_$reflection()], ["Description", string_type], ["UploadDate", class_type("System.DateTime")], ["Name", string_type], ["FileName", string_type], ["VisibleForUserRole", bool_type], ["Url", string_type], ["LinkedReminderInformation", option_type(DocumentDetailLinkedReminderInformation_$reflection())], ["LinkedInspectionResultInformation", option_type(DocumentDetailLinkedInspectionResultInformation_$reflection())]]);
}

function isImage(fileName) {
    if ((fileName.toLocaleLowerCase().endsWith(".jpg") ? true : fileName.toLocaleLowerCase().endsWith(".jpeg")) ? true : fileName.toLocaleLowerCase().endsWith(".png")) {
        return true;
    }
    else {
        return fileName.toLocaleLowerCase().endsWith(".gif");
    }
}

function isPdf(fileName) {
    return fileName.toLocaleLowerCase().endsWith(".pdf");
}

export function ImageGallery(props) {
    return ImageViewer({
        Images: singleton({
            Src: props.ImageUrl,
        }),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
    });
}

export function DocumentTable(props) {
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsUploadDialogOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setIsEditDialogOpen = patternInput_2[1];
    const isEditDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setIsDeleteDialogOpen = patternInput_3[1];
    const isDeleteDialogOpen = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const selectedImage = patternInput_4[0];
    const patternInput_5 = reactApi.useState(undefined);
    const setIsDeleteReminderLinkDialogOpen = patternInput_5[1];
    const isDeleteReminderLinkDialogOpen = patternInput_5[0];
    const rows = map((d) => (new TableDocument(d.Id, d.Description, d.UploadDate, d.Name, d.FileName, d.IsVisibleForUserRole, d.Url, d.LinkedReminderInformation, d.LinkedInspectionResultInformation)), props.Documents);
    const xs_2 = toList(delay(() => append(singleton_1(ImageGallery({
        ImageUrl: defaultArg(selectedImage, ""),
        IsOpen: selectedImage != null,
        OnClose: () => {
            patternInput_4[1](undefined);
        },
    })), delay(() => append(singleton_1(createElement(Upload_FileUploadDialog, {
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsUploadDialogOpen(false);
        },
        SuccessCallback: props.UploadSuccessCallback,
        UploadType: props.UploadType,
    })), delay(() => {
        let matchValue;
        return append((matchValue = isEditDialogOpen, (matchValue == null) ? (empty()) : singleton_1(createElement(Edit_FileEditDialog, {
            Document: matchValue,
            IsOpen: isEditDialogOpen != null,
            IsUserAuthorized: props.UserData.Role !== "user",
            OnClose: () => {
                setIsEditDialogOpen(undefined);
            },
            SuccessCallback: props.UploadSuccessCallback,
            UploadType: props.UploadType,
        }))), delay(() => {
            let matchValue_1;
            return append((matchValue_1 = isDeleteDialogOpen, (matchValue_1 == null) ? (empty()) : singleton_1(createElement(Delete_FileDeleteDialog, {
                Document: matchValue_1,
                IsOpen: isDeleteDialogOpen != null,
                IsUserAuthorized: props.UserData.Role !== "user",
                OnClose: () => {
                    setIsDeleteDialogOpen(undefined);
                },
                SuccessCallback: props.UploadSuccessCallback,
                UploadType: props.UploadType,
            }))), delay(() => {
                let matchValue_2;
                return append((matchValue_2 = isDeleteReminderLinkDialogOpen, (matchValue_2 == null) ? (empty()) : singleton_1(createElement(DeleteDocumentReminderLinkDialog, {
                    IsOpen: isDeleteReminderLinkDialogOpen != null,
                    LinkId: matchValue_2.LinkedReminderInformation.LinkId,
                    OnClose: () => {
                        setIsDeleteReminderLinkDialogOpen(undefined);
                    },
                    SuccessCallback: props.UploadSuccessCallback,
                    UploadType: props.UploadType,
                    UserData: props.UserData,
                }))), delay(() => {
                    let TableRows, Options;
                    return singleton_1(createElement(Table, (TableRows = toArray(rows), (Options = {
                        BorderStyle: "row",
                        CSVDownload: false,
                        ConfigurableColumns: false,
                        CustomTableFilters: false,
                        DefaultSortColumn: ["uploadDate", "desc"],
                        Fullscreen: false,
                        GlobalSearch: true,
                        RowSelection: "singleRow",
                        SaveTableConfiguration: false,
                    }, {
                        ColumnDefinitions: toArray_1(delay(() => append(singleton_1(new ColumnDefinition$1("image", "", t("general.preview"), (row) => {
                            let elems, elems_1;
                            return isPdf(row.FileName) ? (new CellContent(1, [reactElement("div", createObj(ofArray([["onClick", (e) => {
                                e.preventDefault();
                                window.open(row.Url, "_blank", "noreferrer");
                            }], ["className", join(" ", ["flex", "justify-center", "h-5", "cursor-pointer"])], (elems = [Convert_PDF_2()], ["children", reactApi.Children.toArray(Array.from(elems))])])))])) : (isImage(row.FileName) ? (new CellContent(4, [row.Url])) : (new CellContent(1, [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "h-5"])], (elems_1 = [New_File()], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))])));
                        }, "none", "image")), delay(() => append(singleton_1(new ColumnDefinition$1("uploadDate", "", t("tool.uploaded_on"), (row_1) => (new CellContent(7, [row_1.UploadDate])), "none", "dateTime")), delay(() => append(singleton_1(new ColumnDefinition$1("name", "", t("general.name"), (row_2) => (new CellContent(0, [row_2.Name])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("description", "", t("general.description"), (row_3) => (new CellContent(0, [row_3.Description])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("fileName", "", t("general.file_name"), (row_4) => (new CellContent(0, [row_4.FileName])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("visibleForUserRole", "", t("tool.document_visible_for_user_role"), (row_5) => (row_5.VisibleForUserRole ? (new CellContent(0, [t("general.yes")])) : (new CellContent(0, [t("general.no")]))), "select", "text")), delay(() => {
                            let matchValue_3;
                            return append((matchValue_3 = props.UploadType, (matchValue_3.tag === 2) ? singleton_1(new ColumnDefinition$1("linkedReminder", "", t("document_reminder_relation.reminder_link"), (row_6) => {
                                const matchValue_4 = row_6.LinkedReminderInformation;
                                if (matchValue_4 == null) {
                                    const matchValue_6 = props.UserData.Role;
                                    switch (matchValue_6) {
                                        case "user":
                                            return new CellContent(0, [""]);
                                        default:
                                            return new CellContent(1, [createElement(Modal_OpenLinkDocumentWithReminderModalSheet, {
                                                DocumentId: DocumentId__get_unwrap(row_6.Id),
                                                OnClose: () => {
                                                },
                                                OnSuccessCallback: props.UploadSuccessCallback,
                                                UploadType: props.UploadType,
                                                UserData: props.UserData,
                                            })]);
                                    }
                                }
                                else {
                                    const linkedReminderInformation = matchValue_4;
                                    const matchValue_5 = props.UserData.Role;
                                    switch (matchValue_5) {
                                        case "user":
                                            return new CellContent(0, [linkedReminderInformation.ReminderName]);
                                        default:
                                            return new CellContent(1, [createElement(TextButton, {
                                                ComponentState: "enabled",
                                                Label: linkedReminderInformation.ReminderName,
                                                OnClick: () => {
                                                    setIsDeleteReminderLinkDialogOpen({
                                                        DocumentId: DocumentId__get_unwrap(row_6.Id),
                                                        LinkedReminderInformation: linkedReminderInformation,
                                                    });
                                                },
                                                TestId: concat("reminder-", linkedReminderInformation.ReminderId, ..."-test-id"),
                                                Variant: "blueButton",
                                            })]);
                                    }
                                }
                            }, "none", "text")) : ((matchValue_3.tag === 3) ? singleton_1(new ColumnDefinition$1("linkedReminder", "", t("document_reminder_relation.reminder_link"), (row_6) => {
                                const matchValue_4 = row_6.LinkedReminderInformation;
                                if (matchValue_4 == null) {
                                    const matchValue_6 = props.UserData.Role;
                                    switch (matchValue_6) {
                                        case "user":
                                            return new CellContent(0, [""]);
                                        default:
                                            return new CellContent(1, [createElement(Modal_OpenLinkDocumentWithReminderModalSheet, {
                                                DocumentId: DocumentId__get_unwrap(row_6.Id),
                                                OnClose: () => {
                                                },
                                                OnSuccessCallback: props.UploadSuccessCallback,
                                                UploadType: props.UploadType,
                                                UserData: props.UserData,
                                            })]);
                                    }
                                }
                                else {
                                    const linkedReminderInformation = matchValue_4;
                                    const matchValue_5 = props.UserData.Role;
                                    switch (matchValue_5) {
                                        case "user":
                                            return new CellContent(0, [linkedReminderInformation.ReminderName]);
                                        default:
                                            return new CellContent(1, [createElement(TextButton, {
                                                ComponentState: "enabled",
                                                Label: linkedReminderInformation.ReminderName,
                                                OnClick: () => {
                                                    setIsDeleteReminderLinkDialogOpen({
                                                        DocumentId: DocumentId__get_unwrap(row_6.Id),
                                                        LinkedReminderInformation: linkedReminderInformation,
                                                    });
                                                },
                                                TestId: concat("reminder-", linkedReminderInformation.ReminderId, ..."-test-id"),
                                                Variant: "blueButton",
                                            })]);
                                    }
                                }
                            }, "none", "text")) : ((matchValue_3.tag === 1) ? singleton_1(new ColumnDefinition$1("linkedReminder", "", t("document_reminder_relation.reminder_link"), (row_6) => {
                                const matchValue_4 = row_6.LinkedReminderInformation;
                                if (matchValue_4 == null) {
                                    const matchValue_6 = props.UserData.Role;
                                    switch (matchValue_6) {
                                        case "user":
                                            return new CellContent(0, [""]);
                                        default:
                                            return new CellContent(1, [createElement(Modal_OpenLinkDocumentWithReminderModalSheet, {
                                                DocumentId: DocumentId__get_unwrap(row_6.Id),
                                                OnClose: () => {
                                                },
                                                OnSuccessCallback: props.UploadSuccessCallback,
                                                UploadType: props.UploadType,
                                                UserData: props.UserData,
                                            })]);
                                    }
                                }
                                else {
                                    const linkedReminderInformation = matchValue_4;
                                    const matchValue_5 = props.UserData.Role;
                                    switch (matchValue_5) {
                                        case "user":
                                            return new CellContent(0, [linkedReminderInformation.ReminderName]);
                                        default:
                                            return new CellContent(1, [createElement(TextButton, {
                                                ComponentState: "enabled",
                                                Label: linkedReminderInformation.ReminderName,
                                                OnClick: () => {
                                                    setIsDeleteReminderLinkDialogOpen({
                                                        DocumentId: DocumentId__get_unwrap(row_6.Id),
                                                        LinkedReminderInformation: linkedReminderInformation,
                                                    });
                                                },
                                                TestId: concat("reminder-", linkedReminderInformation.ReminderId, ..."-test-id"),
                                                Variant: "blueButton",
                                            })]);
                                    }
                                }
                            }, "none", "text")) : ((matchValue_3.tag === 4) ? (empty()) : singleton_1(new ColumnDefinition$1("linkedReminder", "", t("document_reminder_relation.reminder_link"), (row_6) => {
                                const matchValue_4 = row_6.LinkedReminderInformation;
                                if (matchValue_4 == null) {
                                    const matchValue_6 = props.UserData.Role;
                                    switch (matchValue_6) {
                                        case "user":
                                            return new CellContent(0, [""]);
                                        default:
                                            return new CellContent(1, [createElement(Modal_OpenLinkDocumentWithReminderModalSheet, {
                                                DocumentId: DocumentId__get_unwrap(row_6.Id),
                                                OnClose: () => {
                                                },
                                                OnSuccessCallback: props.UploadSuccessCallback,
                                                UploadType: props.UploadType,
                                                UserData: props.UserData,
                                            })]);
                                    }
                                }
                                else {
                                    const linkedReminderInformation = matchValue_4;
                                    const matchValue_5 = props.UserData.Role;
                                    switch (matchValue_5) {
                                        case "user":
                                            return new CellContent(0, [linkedReminderInformation.ReminderName]);
                                        default:
                                            return new CellContent(1, [createElement(TextButton, {
                                                ComponentState: "enabled",
                                                Label: linkedReminderInformation.ReminderName,
                                                OnClick: () => {
                                                    setIsDeleteReminderLinkDialogOpen({
                                                        DocumentId: DocumentId__get_unwrap(row_6.Id),
                                                        LinkedReminderInformation: linkedReminderInformation,
                                                    });
                                                },
                                                TestId: concat("reminder-", linkedReminderInformation.ReminderId, ..."-test-id"),
                                                Variant: "blueButton",
                                            })]);
                                    }
                                }
                            }, "none", "text")))))), delay(() => {
                                let matchValue_7;
                                return append((matchValue_7 = props.UploadType, (matchValue_7.tag === 0) ? singleton_1(new ColumnDefinition$1("linkedInspectionResult", "", t("document_inspection_result_relation.inspection_result_link"), (row_7) => {
                                    const matchValue_8 = row_7.LinkedInspectionResultInformation;
                                    return (matchValue_8 == null) ? (new CellContent(0, [""])) : (new CellContent(0, [matchValue_8.InspectionResultName]));
                                }, "none", "text")) : ((matchValue_7.tag === 2) ? singleton_1(new ColumnDefinition$1("linkedInspectionResult", "", t("document_inspection_result_relation.inspection_result_link"), (row_7) => {
                                    const matchValue_8 = row_7.LinkedInspectionResultInformation;
                                    return (matchValue_8 == null) ? (new CellContent(0, [""])) : (new CellContent(0, [matchValue_8.InspectionResultName]));
                                }, "none", "text")) : (empty()))), delay(() => props.AdditionalColumns));
                            }));
                        })))))))))))))),
                        Controls: toList(delay(() => {
                            let matchValue_9;
                            return append((matchValue_9 = props.UserData.Role, (matchValue_9 === "system") ? singleton_1(new TableControl$1(t("general.upload_file"), Upload_File(), (_arg_6) => {
                                setIsUploadDialogOpen(true);
                            }, false, false, "")) : ((matchValue_9 === "administrator") ? singleton_1(new TableControl$1(t("general.upload_file"), Upload_File(), (_arg_6) => {
                                setIsUploadDialogOpen(true);
                            }, false, false, "")) : ((matchValue_9 === "toolManager") ? singleton_1(new TableControl$1(t("general.upload_file"), Upload_File(), (_arg_6) => {
                                setIsUploadDialogOpen(true);
                            }, false, false, "")) : (empty())))), delay(() => append(singleton_1(new TableControl$1(t("general.download_file"), Download_File(), (rows_1) => {
                                if (length(rows_1) === 1) {
                                    props.OnDownloadFile([item(0, rows_1).Id, item(0, rows_1).FileName]);
                                }
                            }, true, false, "")), delay(() => {
                                const matchValue_10 = props.UserData.Role;
                                switch (matchValue_10) {
                                    case "system":
                                    case "administrator":
                                    case "toolManager":
                                        return append(singleton_1(new TableControl$1(t("general.edit"), Pencil(), (row_8) => {
                                            const matchValue_11 = tryHead(row_8);
                                            if (matchValue_11 == null) {
                                            }
                                            else {
                                                const row_9 = matchValue_11;
                                                setIsEditDialogOpen(tryFind((doc) => equals(doc.Id, row_9.Id), props.Documents));
                                            }
                                        }, true, false, "")), delay(() => singleton_1(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (row_10) => {
                                            const matchValue_12 = tryHead(row_10);
                                            if (matchValue_12 == null) {
                                            }
                                            else {
                                                const row_11 = matchValue_12;
                                                setIsDeleteDialogOpen(tryFind((doc_1) => equals(doc_1.Id, row_11.Id), props.Documents));
                                            }
                                        }, true, false, ""))));
                                    default: {
                                        return empty();
                                    }
                                }
                            }))));
                        })),
                        Options: Options,
                        TableKey: "not-defined-table",
                        TableRows: TableRows,
                    }))));
                }));
            }));
        }));
    }))))));
    return react.createElement(react.Fragment, {}, ...xs_2);
}

